import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mapings = new Map<ProfiBazaAPIModels.PageOrientation, string>([
	[ProfiBazaAPIModels.PageOrientation.Landscape, 'Poziomy'],
	[ProfiBazaAPIModels.PageOrientation.Portrait, 'Pionowy'],
]);

export const map = (value: ProfiBazaAPIModels.PageOrientation): string =>
	mapings.get(value) ?? '';
